import { Ban, CheckCircle2, CircleX, Clock3 } from 'lucide-react';

import type { DownloadManagerJobStatus } from '@/lib/download-manager-state';
import { cn } from '@/lib/utils';

export function DownloadStatusIcon({
  status,
  className,
}: {
  status: DownloadManagerJobStatus;
  className?: string;
}) {
  if (status === 'ready') {
    return (
      <CheckCircle2
        aria-hidden="true"
        className={cn('text-emerald-500', className)}
      />
    );
  }
  if (status === 'failed') {
    return (
      <CircleX
        aria-hidden="true"
        className={cn('text-destructive', className)}
      />
    );
  }
  if (status === 'expired') {
    return (
      <Clock3 aria-hidden="true" className={cn('text-amber-500', className)} />
    );
  }
  return (
    <Ban
      aria-hidden="true"
      className={cn('text-muted-foreground', className)}
    />
  );
}
